export default __webpack_public_path__ + "static/media/ifCondition.3d383503.svg";